// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// AddInstitutionUserHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import ResultDTO from '../models/ResultDTO';

interface Request {
    institutionId: string | null | null;
    userId: string | null;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            institutionId: null,
            userId: '00000000-0000-0000-0000-000000000000',
        },
        initValues);
    },
    institutionId: 'institutionId',
    userId: 'userId',
}

interface Result extends ResultDTO {
    userId: string | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            userId: '00000000-0000-0000-0000-000000000000',
        },
        initValues);
    },
    userId: 'userId',
}

export { Request, Result };